"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(shape) {
    var _a = shape.attr(), x = _a.x, y = _a.y, r = _a.r;
    return {
        x: x - r,
        y: y - r,
        width: r * 2,
        height: r * 2,
    };
}
exports.default = default_1;
//# sourceMappingURL=circle.js.map